const EVENT = "EVENT";
const LEGISLATIVE = "CAMPAIGN";
const LOOKUP = "LOOKUP";
const PETITION = "PETITION";
const WHODOYOUKNOW = "WHODOYOUKNOW";
const SIGNUP = "ACQ";
const CIVICACTIONCENTER = "CIVICACTIONCENTER";

export default {
  EVENT,
  LEGISLATIVE,
  LOOKUP,
  PETITION,
  WHODOYOUKNOW,
  SIGNUP,
  CIVICACTIONCENTER,
};
